import { lang } from '@umu/ukit-lang';
import { getQueryString, updateUrlParameter } from '@umu/umu-dom';
import { localStorageHelper } from '@umu/umu-storage';

enum ReferSourceField {
    SOURCE_TYPE = 'source',
    SOURCE_TITLE = 'sourceTitle',
    SOURCE_ID = 'sourceId',
}

class ReferSourceService {
    public source: string = '';
    public sourceTitle: string = '';
    public sourceId: string = '';
    constructor() {
        this.init();
    }

    public init = () => {
        this.source = getQueryString(ReferSourceField.SOURCE_TYPE) || '';
        this.sourceTitle = decodeURIComponent(getQueryString(ReferSourceField.SOURCE_TITLE) || '');
        this.sourceId = decodeURIComponent(getQueryString(ReferSourceField.SOURCE_ID) || '');
        if (encodeURIComponent(this.sourceTitle).length > 500) {
            localStorageHelper.set(this.sourceId, this.sourceTitle, 15); // 经验值，双周为一个迭代
        }
    };

    public setProgramUrl(url: string) {
        if (!url) {
            return url;
        }

        if (this.source === '') {
            return url;
        }

        url = updateUrlParameter(url, 'source', this.source);
        if (encodeURIComponent(this.sourceTitle).length <= 500) {
            url = updateUrlParameter(url, 'sourceTitle', this.sourceTitle);
        } else {
            localStorageHelper.set(this.sourceId, this.sourceTitle, 15);
        }
        url = updateUrlParameter(url, 'sourceId', this.sourceId);
        return url;
    }

    public getSourceTitle() {
        return this.sourceTitle || localStorageHelper.get(this.sourceId) || lang('学习项目');
    }

    public getProgramUrl() {
        return `/program/${this.sourceId}`;
    }
}

const referSourceService = new ReferSourceService();

export default referSourceService;
